import React from 'react';

export const SVGAnimation = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100%',
      gap: '16px'
    }}>
      <div style={{
        background: '#1a1a1a',
        padding: '24px',
        border: '1px solid var(--bw)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <svg width="300" height="400" viewBox="0 0 300 400">
          <defs>
            <linearGradient id="flameGradient" x1="0%" y1="100%" x2="0%" y2="0%">
              <stop offset="0%" stopColor="#ffffe0" stopOpacity="1">
                <animate attributeName="stopOpacity" values="1;0.9;1" dur="0.8s" repeatCount="indefinite" />
              </stop>
              <stop offset="20%" stopColor="#ffd700" stopOpacity="0.9">
                <animate attributeName="stopOpacity" values="0.9;0.7;0.9" dur="1.2s" repeatCount="indefinite" />
              </stop>
              <stop offset="50%" stopColor="#ff8c00" stopOpacity="0.7">
                <animate attributeName="stopOpacity" values="0.7;0.5;0.7" dur="1.5s" repeatCount="indefinite" />
              </stop>
              <stop offset="80%" stopColor="#ff4500" stopOpacity="0.4">
                <animate attributeName="stopOpacity" values="0.4;0.2;0.4" dur="2s" repeatCount="indefinite" />
              </stop>
              <stop offset="100%" stopColor="#8b0000" stopOpacity="0" />
            </linearGradient>

            <filter id="flameTurbulence">
              <feTurbulence type="turbulence" baseFrequency="0.05" numOctaves="3" result="turbulence">
                <animate attributeName="baseFrequency" values="0.05;0.08;0.05" dur="2s" repeatCount="indefinite" />
              </feTurbulence>
              <feDisplacementMap in2="turbulence" in="SourceGraphic" scale="8" xChannelSelector="R" yChannelSelector="G" />
            </filter>
          </defs>

          <g>
            <path d="M 150 350 
                     Q 130 320 135 280
                     Q 140 240 145 200
                     Q 148 160 149 120
                     Q 150 80 150 60
                     Q 150 80 151 120
                     Q 152 160 155 200
                     Q 160 240 165 280
                     Q 170 320 150 350 Z" 
                  fill="url(#flameGradient)">
              <animateTransform 
                attributeName="transform" 
                type="translate" 
                values="0,0;-3,2;3,-1;-2,3;2,-2;0,0" 
                dur="1.8s" 
                repeatCount="indefinite"
              />
              <animate 
                attributeName="opacity" 
                values="1;0.8;1;0.9;1" 
                dur="1.5s" 
                repeatCount="indefinite"
              />
            </path>
            
            <path d="M 150 350 
                     Q 138 330 142 290
                     Q 146 250 148 210
                     Q 149 170 150 130
                     Q 150 90 150 80
                     Q 150 90 150 130
                     Q 151 170 152 210
                     Q 154 250 158 290
                     Q 162 330 150 350 Z" 
                  fill="url(#flameGradient)" 
                  opacity="0.7">
              <animateTransform 
                attributeName="transform" 
                type="translate" 
                values="0,0;2,-1;-1,2;-3,-1;1,3;0,0" 
                dur="2.2s" 
                repeatCount="indefinite"
              />
              <animate 
                attributeName="opacity" 
                values="0.7;0.5;0.8;0.6;0.7" 
                dur="1.3s" 
                repeatCount="indefinite"
              />
            </path>
          </g>
          
          <rect x="149" y="350" width="2" height="8" fill="#333333" />
        </svg>
      </div>
      <div style={{ textAlign: 'center' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '20px', fontWeight: '700' }}>SVG Animation</h3>
        <p style={{ margin: '0', opacity: '0.7', fontSize: '14px', fontFamily: 'Source Code Pro, monospace' }}>
          Animated SVG with filters and gradients
        </p>
      </div>
    </div>
  );
};